import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import { formatValueWithType } from "../utils/utility";
import { toast } from 'react-toastify';
import cronstrue from 'cronstrue';

export const listHoldings = (requestPayload, listFormKey) => {
    return async (dispatch, getState) => {
        const { forms = {} } = getState();
        const { formJson = {} } = forms;
        const formData = formJson[listFormKey] || {}
        const listResponse = await getList(requestPayload, "getZerodhaHoldings", "holdings");
        const instrumentSymbols = (listResponse.holdings || [])
            .map(holding => holding?.tradingsymbol)
            .filter(symbol => symbol);
        const listJson = formListJson(formData, listResponse, "holdings");
        dispatch({
            type: actionTypes.ZERODHA.LIST_HOLDINGS,
            payload: listJson,
        });

        if (instrumentSymbols.length > 0) {
            const uniqueSymbols = Array.from(new Set(instrumentSymbols));
            getList(
                { zerodhaInstrumentSymbolIn: uniqueSymbols },
                "getZerodhaHoldingsTrack",
                "list"
            ).then(historyResponse => {
                const chartData = parseHoldingsChartData(historyResponse);
                dispatch({
                    type: actionTypes.ZERODHA.HOLDINGS_CHART_DATA,
                    payload: chartData,
                });
            }).catch((error) => {
                console.log(error);
            });
        }

        return listJson;
    }
};

export const listInstruments = (requestPayload, listFormKey) => {
    return async (dispatch, getState) => {
        const { forms = {} } = getState();
        const { formJson = {} } = forms;
        const formData = formJson[listFormKey] || {}
        const listResponse = await getList(requestPayload, "getZerodhaInstruments", "instruments");
        const listJson = formListJson(formData, listResponse, "instruments");
        return dispatch({
            type: actionTypes.ZERODHA.LIST_INSTRUMENTS,
            payload: listJson,
        });
    }
};

export const listTrades = (requestPayload, listFormKey) => {
    return async (dispatch, getState) => {
        const { forms = {} } = getState();
        const { formJson = {} } = forms;
        const formData = formJson[listFormKey] || {}
        const listResponse = await getList(requestPayload, "listAlertTrades", "list");
        const listJson = formListJson(formData, listResponse, "list");
        return dispatch({
            type: actionTypes.ZERODHA.LIST_TRADES,
            payload: listJson,
        });
    }
};

const formListJson = (formPayload, listPayload, listKey) => {
    const { data = {}, meta = {} } = formPayload;
    const listingData = listPayload[listKey] || [];
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = listingData.map(holding => {
        const rowData = fields.reduce((accum, field, index) => {
            const { additionalInfo = {}, enabled = false, lastRunResult = {}, pattern = '', avgBuyPrice = 0, ltp = 0, totalQty = 0, strategyId = '' } = holding;
            const { tradeInfo = {}, strategyPayload = {}, buyOrderExecuted = false } = additionalInfo;
            const { buyPrices = [], buyQties = [], buyDates = [], sellPrices = [], sellQties = [], sellDates = [] } = tradeInfo;
            const { action = '' } = lastRunResult;
            let value = '';
            const { buyAtEveryDip = [], sellConditions = [], stopLossPercentage = 0, profitTargetPercentage = 0 } = strategyPayload;
            switch (field.id) {
                case "pnlPercentage": {
                    const { averagePrice = 0, pnl = 0, realisedQuantity = 0 } = holding;
                    value = formatValueWithType((pnl / (averagePrice * realisedQuantity)) * 100)
                    break;
                }
                case "buyOrderExecutedDisplay": {
                    value = buyOrderExecuted ? 'Yes' : 'No';
                    break;
                }
                case "buyOrderExecuted": {
                    value = buyOrderExecuted;
                    break;
                }
                case "buyDates":
                case "sellDates":
                    {
                        value = (tradeInfo[field.id] || [])[0] || '';
                        break;
                    }
                case "averageData": {
                    value = buyDates.length > 1 ? buyDates.map((date, idx) => `${date} (Q.${buyQties[idx]} @ Rs.${buyPrices[idx]})`).join(', ') : 'N/A';
                    break;
                }
                case "strategyIdLink": {
                    value = { value: strategyId, link: `/configurations/edit?id=${strategyId}` }
                    break;
                }
                case "avgBuyPrice": {
                    value = formatValueWithType(buyPrices.reduce((accum, price, idx) => { return accum + (price * buyQties[idx]) }, 0) / buyQties.reduce((accum, qty) => accum + qty, 0));
                    break
                }
                case "avgBuyPriceValue": {
                    value = formatValueWithType(avgBuyPrice);
                    break
                }
                case "investedAmount": {
                    value = formatValueWithType(buyPrices.reduce((accum, price, idx) => { return accum + (price * buyQties[idx]) }, 0));
                    break;
                }
                case "quantity": {
                    value = formatValueWithType(buyQties.reduce((accum, qty) => accum + qty, 0), "int");
                    break
                }
                case "avgSellPrice": {
                    value = sellPrices.length > 0 ? formatValueWithType(sellPrices.reduce((accum, price, idx) => { return accum + (price * sellQties[idx]) }, 0) / sellQties.reduce((accum, qty) => accum + qty, 0)) : '';
                    break
                }
                case "action": {
                    if (enabled) {
                        value = ["edit", "delete"];
                    } else {
                        value = ["delete"];
                    }
                    break;
                }
                case "pnl": {
                    value = formatValueWithType((ltp - avgBuyPrice) * totalQty);
                    break;
                }
                case "pnlPercentageTradeTracking": {
                    value = formatValueWithType(((ltp - avgBuyPrice) / avgBuyPrice) * 100);
                    break;
                }
                case "profitTargetPercentage": {
                    value = profitTargetPercentage;
                    break;
                }
                case "stopLossPercentage": {
                    value = stopLossPercentage;
                    break;
                }
                case "sellConditions": {
                    value = sellConditions;
                    break;
                }
                case "buyAtEveryDip": {
                    value = buyAtEveryDip;
                    break;
                }
                case "lastRunAction": {
                    value = lastRunResult.action || 'N/A';
                    break;
                }
                case "lastRunReason": {
                    value = lastRunResult.reason || 'N/A';
                    break;
                }
                case "pattern": {
                    value = pattern ? cronstrue.toString(pattern) : 'N/A';
                    break;
                }
                case "buyOrders": {
                    value = buyPrices.map((price, index) => {
                        return {
                            price, qty: buyQties[index], date: buyDates[index]
                        }
                    });
                    break;
                }
                default: {
                    value = holding[field.id] !== "undefined" ? holding[field.id] : lastRunResult[field.id] !== "undefined" ? lastRunResult[field.id] : '';
                    value = field.type === 'number' ? formatValueWithType(value) : value;
                }
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const executeOrder = (payload) => {
    return async (dispatch, getState) => {
        const options = {
            api: 'executeZerodha',
            content: payload,
        };
        const response = await ExternalApiRequest(options);
        return dispatch({
            type: actionTypes.ZERODHA.EXECUTE_TRADE,
            payload: response,
        });
    }
}

export const clearExecuteOrder = () => {
    return async (dispatch, getState) => {
        return dispatch({
            type: actionTypes.ZERODHA.EXECUTE_TRADE,
            payload: {},
        });
    }
}

const parseHoldingsChartData = (historyPayload) => {
    const { list = [] } = historyPayload;
    const uniqueCompanies = list.reduce((accum, company) => {
        const nseCode = company?.additionalInfo?.nseCode;
        if (!nseCode) {
            accum.fallback.push(company);
            return accum;
        }
        if (!accum.map.has(nseCode)) {
            accum.map.set(nseCode, company);
        }
        return accum;
    }, { map: new Map(), fallback: [] });

    const dedupedList = [
        ...Array.from(uniqueCompanies.map.values()),
        ...uniqueCompanies.fallback
    ];

    const chartValues = dedupedList
        .map((company) => {
            const { name = '', companyId = '', closePriceObj = {} } = company || {};
            const orderedEntries = Object.entries(closePriceObj || {})
                .filter(([date, value]) => date && value !== undefined && value !== null)
                .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
                .reduce((accum, [date, value]) => {
                    // De-dupe by date, keep the latest value encountered for that date
                    accum.map.set(date, value);
                    return accum;
                }, { map: new Map() });
            const uniqueEntries = Array.from(orderedEntries.map.entries());
            const startValue = uniqueEntries[0]?.[1];
            const data = uniqueEntries.map(([date, value]) => ({
                date,
                value: startValue ? formatValueWithType(((value - startValue) / startValue) * 100) : 0,
            }));
            return {
                name: name || companyId,
                data,
            };
        })
        .filter(({ data }) => data.length > 0);

    return { chartValues };
}

export const enableAlertTrade = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            const { alertTradeId = '', enabled = false } = requestPayload;
            const options = {
                api: "enableAlertTrades",
                urlAppend: `/${alertTradeId}/${enabled}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { zerodha = {} } = getState();
            const { trades = {} } = zerodha;
            const { data = [] } = trades;
            const updatedData = data.map(datum => {
                if (datum.alertTradeId == requestPayload.alertTradeId)
                    return { ...datum, ...requestPayload };
                return datum;
            });
            if (success) {
                toast.success('Successfully Updated');
                return dispatch({
                    type: actionTypes.ZERODHA.LIST_TRADES,
                    payload: {
                        ...trades,
                        data: updatedData
                    },
                });
            } else {
                toast.error('Updation failed');
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const deleteAlertTrade = (alertTradeId) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: "deleteAlertTrades",
                urlAppend: `/${alertTradeId}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { zerodha = {} } = getState();
            const { trades = {} } = zerodha;
            const { data = [] } = trades;

            const updatedData = data.filter(datum => datum.alertTradeId != alertTradeId);
            if (success) {
                toast.success('Successfully Updated');
                return dispatch({
                    type: actionTypes.ZERODHA.LIST_TRADES,
                    payload: {
                        ...trades,
                        data: updatedData
                    },
                });
            } else {
                toast.error('Updation failed');
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const updateAlertTrade = (requestPayload, alertTradeId) => {
    return async (dispatch, getState) => {
        const { genericFields = {}, tradeInfo = {}, ...restFirstLevel } = requestPayload;
        const { buyOrderExecuted = false } = genericFields;

        const updatedTrade = {
            alertTradeId,
            additionalInfo: {
                buyOrderExecuted,
                strategyPayload: {
                    ...genericFields,
                    ...restFirstLevel
                },
                tradeInfo
            }
        };
        const options = {
            api: "updateAlertTrades",
            content: updatedTrade
        };
        const response = await ExternalApiRequest(options);
        const { status = {}, } = response;

        if (status.success) {
            toast.success('Successfully Updated');
        }
        return dispatch({
            type: actionTypes.ZERODHA.UPDATE_TRADE,
            payload: response
        });
    }
}

export const clearUpdateTrade = () => {
    return async (dispatch, getState) => {
        return dispatch({
            type: actionTypes.ZERODHA.UPDATE_TRADE,
            payload: {},
        });
    }
}

export const listTrackingTrade = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listTrackingTrade", "list");
            const listJson = formListJson(formData, listResponse, "list");
            return dispatch({
                type: actionTypes.ZERODHA.TRACK_TRADE_LISTING,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}
